import axios from 'axios';
import { getNonGwApiRoot } from '../../../constants/ParamountReactConstants';

export function fetchQuickStartGuideSteps(brandId: number) {
  return {
    type: 'FETCH_GUIDE_STEPS',
    payload: axios.get(`${getNonGwApiRoot()}/parents/owners/brands/${brandId}/home`),
  };
}
